// Empty default → calls go to relative "/api/...", which CRA proxies to the
// local Express server (localhost:3001) in dev and SWA routes to the deployed
// backend in production. Override only if pointing at a non-default host.
import { msalInstance, acquireTokenPopupOnce } from "../msalInstance";
import { apiRequest } from "../msalConfig";

const BASE = process.env.REACT_APP_API_BASE_URL ?? "";

// interactive=false is for background calls (polling): a popup there opens
// without a user click, and repeats on every tick while silent auth fails.
async function getApiToken(interactive: boolean): Promise<string> {
  const account =
    msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];
  if (!account) throw new Error("No user logged in");
  try {
    const res = await msalInstance.acquireTokenSilent({ ...apiRequest, account });
    return res.accessToken;
  } catch (err) {
    if (!interactive) throw err;
    const res = await acquireTokenPopupOnce(apiRequest);
    if (res.account) msalInstance.setActiveAccount(res.account);
    return res.accessToken;
  }
}

// R-02: every backend call goes through here so the FDD-API bearer token is
// always attached. Do not call fetch("/api/...") directly.
export async function apiFetch(
  path: string,
  init: RequestInit = {},
  { interactive = true }: { interactive?: boolean } = {}
): Promise<Response> {
  const token = await getApiToken(interactive);
  const headers = new Headers(init.headers);
  headers.set("Authorization", `Bearer ${token}`);
  return fetch(`${BASE}${path}`, { ...init, headers });
}

export async function postFilesForBlob(
  path: string,
  files: File[],
  extra?: Record<string, string>
): Promise<Blob> {
  const formData = new FormData();
  for (const f of files) formData.append("files", f);
  if (extra) {
    for (const [k, v] of Object.entries(extra)) formData.append(k, v);
  }
  const res = await apiFetch(path, { method: "POST", body: formData });
  if (!res.ok) {
    let message = `Request failed (${res.status})`;
    try {
      const err = await res.json();
      if (err?.error) message = err.error;
    } catch {
      /* ignore */
    }
    throw new Error(message);
  }
  return res.blob();
}

export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
